export type Locale = "en" | "vi" | "zh" | "ja" | "id" | "th" | "es";

export interface StepContent {
  title: string;
  duration?: string;
  badge?: string;
  summary: string;
  details: string[];
  tips?: string[];
}

export interface Translations {
  meta: {
    title: string;
    subtitle: string;
  };
  langName: string;
  steps: {
    booking: StepContent;
    dressing: StepContent;
    makeup: StepContent;
    photography: StepContent;
    returnKimono: StepContent;
    receivePhotos: StepContent;
  };
  photoToggle: {
    fileDelivery: string;
    editedPackage: string;
    fileDeliveryDetails: string[];
    editedPackageDetails: string[];
  };
  cta: {
    checkPricing: string;
    calculateCost: string;
  };
  common: {
    tip: string;
    optional: string;
    stepOf: string;
    expandToRead: string;
  };
}

export const LOCALE_CONFIG: Record<Locale, { flag: string; name: string }> = {
  en: { flag: "🇬🇧", name: "English" },
  vi: { flag: "🇻🇳", name: "Tiếng Việt" },
  zh: { flag: "🇨🇳", name: "中文" },
  ja: { flag: "🇯🇵", name: "日本語" },
  id: { flag: "🇮🇩", name: "Indonesia" },
  th: { flag: "🇹🇭", name: "ภาษาไทย" },
  es: { flag: "🇪🇸", name: "Español" },
};
